export const PRIMARY_NAVIGATION_TEST_IDS = {
  actions: 'primary-navigation__actions',
  brand: 'primary-navigation__brand',
  context: 'primary-navigation__context',
  root: 'primary-navigation',
  skeleton: 'primary-navigation__skeleton',
  tab: (value: string) => `primary-navigation__tab-${value}`,
} as const;
